@for (task of tasks; track taskTrackBy($index, task)) {
  <rt-task-item
    [task]="task"
    [editableCandidate]="editableCandidate"
    [canViewCandidatesSection]="canViewCandidates"
    [adminTimezone]="currentAdmin?.timezone!"
    (openTaskEditDialog)="onOpenTaskEditDialog($event)"
    (taskToggle)="onTaskToggle($event)"
    data-cy="task-item:container"
  />
}
